export const tutorSessionUpdateLoading =  ({store})  => store.tutorSessionUpdateReducer.loading;

export const tutorSessionUpdateError =  ({store})  => store.tutorSessionUpdateReducer.error;

export const tutorSessionUpdateData =  ({store})  => store.tutorSessionUpdateReducer.data;